import React, { useMemo } from "react"
import { useSearchParams } from "react-router-dom"

import { ProjectTypename } from "shared/types/Project"

const DEFAULT_PAGE_TYPE = "Default" as const

export interface DefaultPageContext {
  pageType: typeof DEFAULT_PAGE_TYPE
}

export interface ProjectPageContext {
  id: string
  pageType: typeof ProjectTypename
}

export type PageContextType = ProjectPageContext | DefaultPageContext

export function isProjectPageContext(
  pageContext: PageContextType
): pageContext is ProjectPageContext {
  return pageContext.pageType === ProjectTypename
}

const defaultPageContextValue: DefaultPageContext = {
  pageType: DEFAULT_PAGE_TYPE
}

export const PageContext = React.createContext<PageContextType>(
  defaultPageContextValue
)

interface ProjectPageContextProviderProps {
  children?: React.ReactNode | React.ReactNode[]
}

export const PageContextProvider = React.memo(
  ({ children }: ProjectPageContextProviderProps) => {
    const [params] = useSearchParams()
    const projectID = params.get("project_id")

    const context = useMemo<PageContextType>(() => {
      if (projectID) {
        return {
          id: projectID,
          pageType: ProjectTypename
        }
      }
      return defaultPageContextValue
    }, [projectID])

    return (
      <PageContext.Provider value={context}>{children}</PageContext.Provider>
    )
  }
)
